import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useImportacaoList() {
  // Use toast
  const toast = useToast()

  const refImportacaoListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'nome_arquivo', label:"Nome Arquivo"},
    { key: 'categoria' },
    { key: 'usuario' },
    { key: 'inicio' },
    { key: 'situacao' },
    { key: 'fim' },
    { key: 'total_linhas' },
    { key: 'total_cadastros' },
  ]
  const perPage = ref(10)
  const currentPage = ref(1)
  const perPageOptions = [10, 15, 25, 50, 100]
  const searchQuery = ref('')
  const situacaoFilter = ref(null)

  const dataMeta = ref({})


  const refetchData = () => {
    refImportacaoListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, situacaoFilter], () => {
    refetchData()
  })

  const fetchImportacoes = (ctx, callback) => {
    store
      .dispatch('app-importacao/fetchImportacoes', {
        busca: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        // situacao: situacaoFilter.value,
      })
      .then(response => {
        const { data, meta } = response.data     
        callback(data)
        dataMeta.value = meta
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching importacao list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveImportacaoStatusVariant = status => {
    if (status === 'PENDENTE') return 'secondary'
    if (status === 'EM PROGRESSO') return 'info'
    if (status === 'FINALIZADO') return 'success'
    if (status === 'FALHA') return 'danger'
    return 'primary'
  }

  return {
    fetchImportacoes,
    tableColumns,
    perPage,
    currentPage,
    dataMeta,
    perPageOptions,
    searchQuery,
    refImportacaoListTable,

    resolveImportacaoStatusVariant,
    refetchData,

    // Extra Filters
    situacaoFilter,
  }
}
